import React from 'react'
import styled from 'styled-components';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import CategoriesEditableItem from './CategoriesEditableItem';

const Container = styled.div`
`;

const Header = styled.div`
    height:50px;
    display:flex;
    background-color:#ECF5F9;
    padding-left:20px;
    padding-right:20px;
    align-items:center;
    justify-content:space-between;
    font-family: Roboto;
    font-size: 17px;
    font-weight: 500;

`;



class CategoriesAdd extends React.Component {

    state = {
        expanded : false,
    }

    render () {
        return (
            <Container>
                <Header>
                    <div>Categories</div>
                    {!this.state.expanded && <Button onClick={() => this.setState({expanded:true})}>+ Create New Category</Button>}
                </Header>
                {this.state.expanded && 
                    <CategoriesEditableItem 
                        onCancel={() => this.setState({expanded:false})}
                        onConfirm={values => {
                            this.props.arrayHelpers.insert(0,values);
                            this.setState({expanded:false})
                        }}
                        
                    />
                }
            </Container>
        );
    }
}

export default CategoriesAdd;